"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
// Libs AssetResultsGrid
var react_1 = require("react");
require("./styles.css");
var react_outside_click_handler_1 = __importDefault(require("react-outside-click-handler"));
var AssetPagination_1 = __importDefault(require("@component/AssetPagination"));
var SearchResultsComponent_1 = __importDefault(require("@component/SearchResultsComponent"));
var brandcenter_icon_1 = __importDefault(require("@rotaryintl/brandcenter-icon"));
function AssetResultsGrid(_a) {
    var _b, _c;
    var resultGridData = _a.resultGridData, slideNumber = _a.slideNumber, pageSize = _a.pageSize, pageLabel = _a.pageLabel, totalCount = _a.totalCount, onPaginationChange = _a.onPaginationChange;
    var currentPage = slideNumber;
    var _d = (0, react_1.useState)(0), current = _d[0], setCurrent = _d[1];
    var _e = (0, react_1.useState)(false), display = _e[0], setDisplay = _e[1];
    var pgSize = pageSize !== null && pageSize !== void 0 ? pageSize : 10;
    var firstPageIndex = (_b = (currentPage - 1) * pgSize) !== null && _b !== void 0 ? _b : 0;
    var lastPageIndex = (_c = firstPageIndex + pgSize) !== null && _c !== void 0 ? _c : 0;
    var onPageChange = function (page) {
        return onPaginationChange(page);
    };
    var totallength = resultGridData === null || resultGridData === void 0 ? void 0 : resultGridData.length;
    var handleModalClick = function (e) {
        var select = Number(e.currentTarget.dataset.id);
        setDisplay(true);
        setCurrent(select);
        document.querySelector("body").style.overflow = "hidden";
    };
    var handleClose = function () {
        setDisplay(false);
        document.querySelector("body").style.overflow = "";
    };
    var handleNext = function () {
        var next = current;
        if (next < totallength - 1) {
            setCurrent(++next);
        }
    };
    var handlePrev = function () {
        var prev = current;
        if (prev > 0) {
            setCurrent(prev - 1);
        }
    };
    (0, react_1.useEffect)(function () {
        var handleKeyDown = function (event) {
            if ([9, 112].indexOf(event) !== -1) {
                event.preventDefault();
                event.stopPropagation();
            }
            switch (event.keyCode) {
                case 27:
                    handleClose();
                    break;
                case 37:
                    handlePrev();
                    break;
                case 39:
                    handleNext();
                    break;
                default:
                    break;
            }
        };
        window.addEventListener("keydown", handleKeyDown);
        return function () { return window.removeEventListener("keydown", handleKeyDown); };
    }, []);
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsxs)("div", __assign({ className: "result_grid_box" }, { children: [resultGridData &&
                        resultGridData.map(function (item, idx) {
                            var _a;
                            return ((0, jsx_runtime_1.jsxs)("div", __assign({ className: "result_grid", onClick: handleModalClick, "data-id": item.index }, { children: [(0, jsx_runtime_1.jsxs)("div", __assign({ className: "result_grid_image" }, { children: [(0, jsx_runtime_1.jsx)("div", __assign({ className: "result_grid_data" }, { children: (_a = item.grid) === null || _a === void 0 ? void 0 : _a.file })), ((item === null || item === void 0 ? void 0 : item.type) === "video") && ((0, jsx_runtime_1.jsx)(brandcenter_icon_1.default, { iconType: "playCircle", color: "#FFFFFF", size: "medium" }))] })), (0, jsx_runtime_1.jsx)("div", __assign({ className: "resilt_grid_title" }, { children: item.grid.title }))] }), idx));
                        }), display && ((0, jsx_runtime_1.jsx)("div", __assign({ className: "modal" }, { children: (0, jsx_runtime_1.jsx)("div", __assign({ className: "modal__body" }, { children: (0, jsx_runtime_1.jsxs)(react_outside_click_handler_1.default, __assign({ onOutsideClick: function () {
                                    setDisplay(false);
                                    document.querySelector("body").style.overflow =
                                        "";
                                } }, { children: [(0, jsx_runtime_1.jsx)("button", __assign({ className: "close__btn", onClick: handleClose }, { children: (0, jsx_runtime_1.jsx)("svg", __assign({ width: "20", height: "20", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: (0, jsx_runtime_1.jsx)("path", { d: "M21 1.25269L1 21.2527M1 1.25269L21 21.2527", stroke: "#39424A", strokeWidth: "1.5" }) })) })), (0, jsx_runtime_1.jsx)(SearchResultsComponent_1.default, { data: resultGridData[current], slideNumber: current }), (0, jsx_runtime_1.jsxs)("div", __assign({ className: "modal__controls" }, { children: [(0, jsx_runtime_1.jsx)("button", __assign({ className: "prev", onClick: handlePrev, disabled: current === 0 ? true : false }, { children: (0, jsx_runtime_1.jsx)("svg", __assign({ width: "32", height: "68", xmlns: "http://www.w3.org/2000/svg", fill: "none" }, { children: (0, jsx_runtime_1.jsx)("path", { transform: "rotate(-180 16 34)", id: "svg_1", fill: "white", d: "m29.91496,35.23924l0.56,0.4983c0.25,-0.2762 0.25,-0.6899 0.02,-0.9751l-0.58,0.4768zm-27.44,31.9983l28,-31.5l-1.12,-0.9966l-28,31.5l1.12,0.9966zm28.02,-32.4751l-28,-33.99998l-1.16,0.95356l28,34.00002l1.16,-0.9536z" }) })) })), (0, jsx_runtime_1.jsx)("button", __assign({ className: "next", onClick: handleNext, disabled: current === totallength - 1 ? true : false }, { children: (0, jsx_runtime_1.jsx)("svg", __assign({ width: "32", height: "68", xmlns: "http://www.w3.org/2000/svg", fill: "none" }, { children: (0, jsx_runtime_1.jsx)("path", { id: "svg_1", fill: "white", d: "m29.91496,35.23924l0.56,0.4983c0.25,-0.2762 0.25,-0.6899 0.02,-0.9751l-0.58,0.4768zm-27.44,31.9983l28,-31.5l-1.12,-0.9966l-28,31.5l1.12,0.9966zm28.02,-32.4751l-28,-33.99998l-1.16,0.95356l28,34.00002l1.16,-0.9536z" }) })) }))] }))] })) })) })))] })), (0, jsx_runtime_1.jsx)(AssetPagination_1.default, { pageLabel: pageLabel, onPageChange: onPageChange, pageSize: pgSize, currentPage: currentPage, totalCount: totalCount || 0 })] }));
}
exports.default = AssetResultsGrid;
//# sourceMappingURL=index.js.map